import { Footer } from "../components/footer/footer";
import { Scroll } from "../components/scroll/scroll";
import { Header } from "../components/header/header";
import { useI18n } from '../i18n';

export default function Contact() {
    const { translations } = useI18n();

    return (
        <Scroll>
            <main className="page">
                <Header
                    title={translations.contact.title}
                    // description={translations.contact.description}
                    breadcrumbs={[
                        { label: 'GAraujo', href: '/' },
                        { label: translations.contact.title, href: '/contact' },
                    ]}
                />
                <div className="content">
                <section>
                    <article>
                        <h2>{translations.contact.heading}</h2>
                        <p>{translations.contact.professional}<a href="https://linkedin.com/in/guilhermeasouza" target="_blank" rel="noopener noreferrer">{translations.contact.linkedIn}</a>.</p>
                        <p>{translations.contact.personal}<a href="mailto:garaujo.work@gmail.com">{translations.contact.email}</a>.</p>
                        <p><a href="https://aifront.substack.com" target="_blank">substack</a> | <a href="https://linkedin.com/in/guilhermeasouza" target="_blank">linkedin</a> | <a href="https://codepen.io/fromspace" target="_blank">codepen</a> | <a href="https://www.behance.net/guilhermeasouza" target="_blank">behance</a></p>
                    </article>
                </section>
                </div>
                <Footer />
            </main >
        </Scroll>
    );
}